<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách yêu cầu đăng ký combo bán hàng</h1>
      <div class="btn-group gap-2">
        <b-button @click="exportExcel" variant="primary">
          <i class="bx bx-download"></i><span>&nbsp;</span>
          {{ loadingExport ? 'Đang tải...' : ' Tải file' }}
        </b-button>
        <b-button @click="$router.push(`/sales-combos-add`)" variant="success">
          <i class="bx bx-plus"></i><span>&nbsp;</span>
          Thêm mới
        </b-button>
      </div>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <div class="card-header">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker class="w-100" :ranges="false" @update="transfromDate()" v-model="dateRange"
              :locale-data="localeData">
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em"
                  class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input type="text" v-model.trim="search.keyword" class="form-control f12 hc-37 text-search"
              placeholder="Mã yêu cầu/Tên MC/ĐKKD" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái"></Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.paymentStatus" :options="optionPaymentStatus" placeholder="Trạng thái thanh toán">
            </Select2>
          </div>

          <div class="form-group form-group-action">
            <button @click="submitForm" class="pt-2 mr-2 btn btn-primary hc-37" data-toggle="tooltip"
              data-placement="top" title="Lọc">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button @click="resetFilters" type="button" class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip" data-placement="top" title="Bỏ lọc">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="mb-2">
              <div class="status-summary-compact mb-0">
                <div>
                  <!-- Tổng số -->
                  <div class="total-item">
                    <span class="total-label">Tổng:</span>
                    <span class="total-number text-primary">{{ pagination?.total | formatNumberVN }}</span>
                  </div>

                  <!-- Trạng thái chung -->
                  <div class="status-group" v-if="statusObj?.listCountStatus">
                    <span class="group-title">
                      Trạng thái:
                    </span>
                    <div class="status-items">
                      <span v-for="(item, index) in statusObj.listCountStatus" :key="index" class="status-item">
                        {{ item.statusStr }}: <strong>{{ item.count | formatNumberVN }}</strong>
                      </span>
                    </div>
                  </div>

                  <!-- Trạng thái CKS -->
                  <div class="status-group" v-if="statusObj?.listCountSignatureStatus">
                    <span class="group-title">
                      Trạng thái CKS:
                    </span>
                    <div class="status-items">
                      <span v-for="(item, index) in statusObj.listCountSignatureStatus" :key="index"
                        class="status-item">
                        {{ item.statusStr }}: <strong>{{ item.count | formatNumberVN }}</strong>
                      </span>
                    </div>
                  </div>

                  <!-- Trạng thái thuế -->
                  <div class="status-group" v-if="statusObj?.listCountTaxStatus">
                    <span class="group-title">
                      Trạng thái Thuế:
                    </span>
                    <div class="status-items">
                      <span v-for="(item, index) in statusObj.listCountTaxStatus" :key="index" class="status-item">
                        {{ item.statusStr }}: <strong>{{ item.count | formatNumberVN }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-overlay :show="loading" opacity="0.6" rounded="sm">
              <b-table sticky-header hover responsive :items="list" :fields="tableFields" :fixed="true"
                :bordered="true">

                <template #cell(index)="data">
                  {{ getIndex(data.index) }}
                </template>

                <template #cell(createdDate)="data">
                  <p v-if="data.item.createdDate">
                    {{ data.item.createdDate | formatDate("DD/MM/YYYY HH:mm") }}
                  </p>
                </template>

                <template #cell(packageCode)="data">
                  <p v-if="data.item.packageCode">
                    {{ getNameCombo(data.item.packageCode) || '' }}
                  </p>
                </template>

                <template #cell(status)="data">
                  <div class="badge" :class="getStatusBadgeClass(data.item.status)">
                    {{ data.item.statusStr || data.item.status }}
                  </div>
                </template>
                <template #cell(digitalSignatureRegistrationStatusStr)="data">
                  <div v-if="data.item.digitalSignatureRegistrationStatusStr" class="badge"
                    :class="getDigitalSignatureRegistrationStatus(data.item.digitalSignatureRegistrationStatus)">
                    {{ data.item.digitalSignatureRegistrationStatusStr || data.item.digitalSignatureRegistrationStatus
                    }}
                  </div>

                </template>
                <template #cell(taxAuthorityVerifyStatusStr)="data">
                  <div v-if="data.item?.taxAuthorityVerifyStatusStr" class="badge"
                    :class="getTaxAuthorityVerifyStatus(data.item?.taxAuthorityVerifyStatus)">
                    {{ data.item?.taxAuthorityVerifyStatusStr || data.item?.taxAuthorityVerifyStatus }}
                  </div>
                </template>

                <template #cell(paymentStatus)="data">
                  <p v-if="data.item.paymentStatus" class="badge"
                    :class="getPaymentStatusBadgeClass(data.item.paymentStatus)">
                    {{ data.item.paymentStatusStr || data.item.paymentStatus }}
                  </p>
                </template>

                <template #cell(merchantName)="{ item }">
                  <p>Tên: {{ item?.merchantName }}</p>
                  <p>ĐKKD: {{ item?.businessRegistrationNumber }}</p>
                  <p>Đại chỉ: {{ item?.merchantAddress }}</p>
                </template>
                <template #cell(reason)="{ item }">
                  <p v-if="item?.supplementRequestReason">Lý do bổ sung: {{ item?.supplementRequestReason }}</p>
                  <p v-if="item?.supplementRequestNote">Ghi chú bổ sung: {{ item?.supplementRequestNote }}</p>

                  <p v-if="item?.rejectionReason">Lý do từ chối: {{ item?.rejectionReason }}</p>
                  <p v-if="item?.rejectionNote">Ghi chú từ chối: {{ item?.rejectionNote }}</p>

                  <p v-if="item?.digitalSignatureRejectionReason">Lý do CKS từ chối: {{
                    item?.digitalSignatureRejectionReason }}</p>
                  <p v-if="item?.digitalSignatureRejectionNote">Ghi chú CKS từ chối: {{
                    item?.digitalSignatureRejectionNote }}</p>

                  <p v-if="item?.taxAuthorityRejectionReason">Lý do CQ thuế từ chối: {{
                    item?.taxAuthorityRejectionReason
                    }}</p>
                  <p v-if="item?.taxAuthorityRejectionNote">Ghi chú CQ thuế từ chối: {{ item?.taxAuthorityRejectionNote
                    }}
                  </p>
                </template>

                <template #cell(action)="{ item }">
                  <!-- <b-dropdown  variant="primary">
                  <b-dropdown-item @click="viewDetails(item.id)">
                    <i class="fas fa-eye me-2"></i>Xem chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item @click="editItem(item.id)">
                    <i class="fas fa-edit me-2"></i>Cập nhật
                  </b-dropdown-item>
                  <b-dropdown-item @click="editItem(item.id)">
                    <i class="fas fa-plus-circle me-2"></i>Cập nhật bổ sung
                  </b-dropdown-item>
                  <b-dropdown-item @click="deleteItem(item.id)" class="text-danger">
                    <i class="fas fa-trash me-2"></i>Hủy
                  </b-dropdown-item>
                </b-dropdown> -->

                  <button v-if="
                    dataUser &&
                    dataUser.permissionCodes?.includes(
                      'CNPS_AGENT_COMBO_REGISTRATION_REQUEST_CREATE'
                    )
                  " class="btn btn-info btn-sm mr-2" @click="viewDetails(item.id)">
                    Chi tiết
                  </button>
                </template>
              </b-table>
            </b-overlay>

          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination v-model="search.page" :total-rows="pagination.total" :per-page="search.limit"
          class="mr-4 fl-right"></b-pagination>
      </div>
    </div>

    <!-- Modal thêm mới -->
    <b-modal id="addModal" v-model="showAddModal" title="Thêm yêu cầu đăng ký combo" @ok="addNewRequest"
      @cancel="closeAddModal" ok-title="Thêm mới" cancel-title="Hủy" :ok-disabled="addLoading">
      <div class="form-group">
        <label for="merchantName">Tên merchant: <span class="text-danger">*</span></label>
        <input id="merchantName" type="text" v-model="newRequest.merchantName" class="form-control"
          placeholder="Nhập tên merchant" :disabled="addLoading" />
      </div>

      <div class="form-group">
        <label for="businessRegistrationNumber">Mã số thuế: <span class="text-danger">*</span></label>
        <input id="businessRegistrationNumber" type="text" v-model="newRequest.businessRegistrationNumber"
          class="form-control" placeholder="Nhập mã số thuế" :disabled="addLoading" />
      </div>

      <div class="form-group">
        <label for="agentName">Đại lý:</label>
        <input id="agentName" type="text" v-model="newRequest.agentName" class="form-control"
          placeholder="Nhập tên đại lý" :disabled="addLoading" />
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel()" :disabled="addLoading">
          Hủy
        </button>
        <button type="button" class="btn btn-primary" @click="ok()"
          :disabled="addLoading || !newRequest.merchantName.trim() || !newRequest.businessRegistrationNumber.trim()">
          <span v-if="addLoading" class="spinner-border spinner-border-sm mr-2"></span>
          {{ addLoading ? 'Đang thêm...' : 'Thêm mới' }}
        </button>
      </template>
    </b-modal>
    <ModalExportNoti ref="uploadNotif" />
  </div>
</template>

<script>
import { ComboService } from '@/services/combo.service'
import moment from 'moment'
import Config from '@/thirdParty/config'
import ModalExportNoti from '@/components/ModalExportNoti.vue'
import { CommonService } from '@/services/common.service'


const tableFields = [
  { key: 'index', label: 'STT' },
  { key: 'code', label: 'Mã yêu cầu' },
  { key: 'createdDate', label: 'Thời gian tạo' },
  { key: 'merchantName', label: 'Tên merchant' },
  // { key: 'businessRegistrationNumber', label: 'Mã số thuế' },
  { key: 'status', label: 'Trạng thái' },
  { key: 'digitalSignatureRegistrationStatusStr', label: 'TT CKS' },
  { key: 'taxAuthorityVerifyStatusStr', label: 'TT TĐ Thuế' },
  { key: 'packageCode', label: 'Gói combo' },
  { key: 'paymentStatus', label: 'Trạng thái thanh toán' },
  { key: 'reason', label: 'Ghi chú' },
  // { key: 'reason', label: 'Ghi chú' },
  { key: 'inviteCode', label: 'Mã giới thiệu' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]

export default {
  name: 'ComboRegistrationList',
  components: {
    ModalExportNoti
  },
  data() {
    return {
      localeData: Config.localeData,
      showAddModal: false,
      addLoading: false,
      newRequest: {
        merchantName: '',
        businessRegistrationNumber: '',
        agentName: ''
      },
      loading: false,
      showLoading: false,
      tableFields,
      optionStatus: Config.optionStatusCombo,
      optionPaymentStatus: Config.optionPaymentStatusCombo,
      list: [],
      search: {
        page: 1,
        limit: 20,
        countStatus: true

      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      pagination: {
        total: 1
      },
      dataUser: JSON.parse(localStorage.getItem('userData')),
      statusObj: null,
      optionCombo: [],
      loadingExport: false
    }
  },

  filters: {
    transformData(data, dataConfig) {
      const dataReturn = dataConfig.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].text
    },
    formatDate(dateString, format = 'DD/MM/YYYY') {
      if (!dateString) return ''
      return moment(dateString).format(format)
    }
  },

  async mounted() {
    await this.fetchData()
    this.loadNameCombo()
  },

  watch: {
    'search.limit': function () {
      this.fetchData()
    },
    'search.page': function () {
      this.fetchData()
    }
  },
  computed: {
    getNameCombo() {
      return (code) => {
        const map = this.optionCombo.reduce((acc, curr) => {
          acc[curr.id] = curr.text
          return acc
        }, {})
        return map[code] || code || ''
      }
    },
  },

  methods: {
    openModalLoadFile(id) {
      this.$refs.uploadNotif.triggerNotification(id)
    },
    async exportExcel() {
      try {
        this.loadingExport = true

        for (const key in this.search) {
          if (this.search[key] === '' || this.search[key] === null || this.search[key] === '0') delete this.search[key]
        }

        const body = {
          object: this.search,
          type: 'CNPS_AGENT_REQUEST_COMBO'
        }

        const data = await CommonService.receiveFile(body)

        if (data.success) {
          await this.openModalLoadFile(data.data.id)
        }
      } catch (error) {
        this.showFailMx(`Lỗi: ${error.message}`)
      } finally {
        this.loadingExport = false
      }
    },
    async loadNameCombo() {
      try {
        const data = await ComboService.getPlaneServiceCommbo({
          page: 1,
          size: 1000
        })
        if (data.code === 1000) {
          const groupService = data.data?.groupService?.find(e => e.group === 'SELL')
          const comboService = groupService?.service?.find(e => e.code === 'COMBOSELL')
          const plans = comboService?.plan || []
          const newData = plans?.filter(e => Array.isArray(e?.partnerEnable) && e.partnerEnable.includes(`${this.dataUser?.partnerCode}_DIGITAL`)) || [];
          this.dataCombo = newData || []
          this.optionCombo = newData?.map(e => {
            return {
              id: e.code,
              text: e.title,
              partnerPrice: e.partnerPrice
            }
          }) || []
        }
      } catch (error) {
        console.log(error)
      }
    },
    getDigitalSignatureRegistrationStatus(status) {
      const map = Config.digitalSignatureRegistrationStatus?.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[status] || 'badge-secondary'
    },
    getTaxAuthorityVerifyStatus(status) {
      const map = Config.taxAuthorityVerifyStatus?.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[status] || 'badge-secondary'
    },
    transfromDate() {
      this.search.fromDate = moment(this.dateRange.startDate)
        .startOf('day')
        .valueOf()
      this.search.toDate = moment(this.dateRange.endDate)
        .endOf('day')
        .valueOf()
    },
    getIndex(index) {
      return (this.search.page - 1) * this.search.limit + index + 1
    },

    getStatusBadgeClass(status) {
      const map = this.optionStatus.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[status] || 'badge-secondary'
    },

    getPaymentStatusBadgeClass(paymentStatus) {
      const map = this.optionPaymentStatus.reduce((acc, curr) => {
        acc[curr.id] = curr.bgColor
        return acc
      }, {})
      return map[paymentStatus] || 'badge-secondary'
    },

    openAddModal() {
      this.showAddModal = true
    },

    closeAddModal() {
      this.showAddModal = false
      this.newRequest = {
        merchantName: '',
        businessRegistrationNumber: '',
        agentName: ''
      }
      this.addLoading = false
    },

    async addNewRequest() {
      if (!this.newRequest.merchantName.trim() || !this.newRequest.businessRegistrationNumber.trim()) {
        this.showFailMx('Vui lòng nhập đầy đủ thông tin bắt buộc')
        return
      }

      try {
        this.addLoading = true

        // Gọi API thêm mới
        const response = await ComboService.createRequest(this.newRequest)

        if (response.code === 1000) {
          this.showSuccessMx('Thêm yêu cầu thành công')
          await this.fetchData()
          this.closeAddModal()
        } else {
          this.showFailMx(response.message ?? 'Có lỗi xảy ra khi thêm yêu cầu')
        }
      } catch (error) {
        console.error('Error adding request:', error)
        this.showFailMx(error.message ?? 'Có lỗi xảy ra khi thêm yêu cầu')
      } finally {
        this.addLoading = false
      }
    },

    async submitForm(event) {
      event.preventDefault()
      this.search.page = 1
      await this.fetchData()
    },

    async resetFilters() {
      this.search = {
        page: 1,
        limit: 20,
        countStatus: true
      }
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      await this.fetchData()
    },

    viewDetails(id) {
      this.$router.push(`/sales-combos-detail/${id}`)
    },

    editItem(id) {
      this.$router.push(`/combo-registration/edit/${id}`)
    },

    async deleteItem(id) {
      if (confirm('Bạn có chắc chắn muốn xóa yêu cầu này?')) {
        try {
          const response = await ComboService.deleteRequest(id)
          if (response.code === 1000) {
            this.showSuccessMx('Xóa yêu cầu thành công')
            await this.fetchData()
          } else {
            this.showFailMx(response.message ?? 'Có lỗi xảy ra khi xóa yêu cầu')
          }
        } catch (error) {
          console.error('Error deleting request:', error)
          this.showFailMx(error.message ?? 'Có lỗi xảy ra khi xóa yêu cầu')
        }
      }
    },

    async fetchData() {
      if (!this.loading) this.showLoading = true
      try {
        this.loading = true

        // Loại bỏ giá trị rỗng
        for (const key in this.search) {
          if (this.search[key] === '' || this.search[key] === null || this.search[key] === '0') delete this.search[key]
        }
        this.search.isAgentView = true

        const response = await ComboService.getList(this.search)
        if (response.code === 1000) {
          this.list = response.data || []
          this.pagination.total = response.totalPage.total || 0
          this.statusObj = response.meta.metaData
        } else {
          this.list = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.box-search {
  display: flex;
  flex-wrap: wrap;
}

.form-group {
  margin-bottom: 10px;
  min-width: 200px;
}

.form-group-action {
  display: flex;
  align-items: flex-end;
}

.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.status-summary-compact {
  /* background: #f8f9fa; */
  border-radius: 6px;
  /* padding: 12px; */
  /* border: 1px solid #e9ecef; */
}

.status-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  font-size: 13px;
}

.total-label {
  font-weight: 600;
  font-family: sans-serif;
}

.total-item {
  display: flex;
  align-items: center;
  gap: 6px;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  /* color: white; */
  /* padding: 6px 12px; */
  border-radius: 20px;
  font-weight: 500;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
}

.total-item i {
  font-size: 14px;
}

.total-number {
  font-weight: bold;
  font-family: sans-serif;
}

.status-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.group-title {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
  font-family: sans-serif;
}

.group-title i {
  font-size: 14px;
}

.status-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.status-item {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  white-space: nowrap;
  border: 1px solid #007bff;
  line-height: 12px;

}

.status-item strong {
  font-weight: bold;
}
</style>
